import { Paths } from 'shared/routes/paths';

export const LifeAreaDetailRoutes = [
  {
    path: Paths.LifeAreaDetail,
    lazy: async () => ({ Component: (await import('./summary')).Summary }),
  },
  {
    path: Paths.LifeAreaDetailVision,
    lazy: async () => ({ Component: (await import('./vision')).Vision }),
  },
  {
    path: Paths.LifeAreaDetailRoadmap,
    lazy: async () => ({ Component: (await import('./roadmap')).Roadmap }),
  },
  {
    path: Paths.LifeAreaDetailTasks,
    lazy: async () => {
      const { Tasks } = await import('./tasks');
      return { element: <Tasks fullSize /> };
    },
  },
];
